import "core-js/modules/es6.function.name";
var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  token: function token(state) {
    return state.user.token;
  },
  phone: function phone(state) {
    return state.user.phone;
  },
  name: function name(state) {
    return state.user.name;
  },
  user_id: function user_id(state) {
    return state.user.user_id;
  },
  school_id: function school_id(state) {
    return state.user.school_id;
  },
  school_name: function school_name(state) {
    return state.user.school_name;
  },
  account_type: function account_type(state) {
    return state.user.account_type;
  },
  role: function role(state) {
    return state.user.role;
  },
  menus: function menus(state) {
    return state.user.menus;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routers;
  },
  addRouters: function addRouters(state) {
    return state.permission.addRouters;
  },
  roles: function roles(state) {
    return state.user.roles;
  }
};
export default getters;